import { ButtonBase, Chip, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { addTransparency } from "../../../../application/styles/colorStyles";
import { Add } from "@mui/icons-material";


interface ForecastGradeProps {
    grade?: string;
    size?: 'small' | 'medium' | 'large';
    disabled?: boolean;
    showLabel?: boolean;
    grade_reasons?: Record<string, string>;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const ForecastGrade = ({ grade, size = 'small', disabled = false, showLabel = false, grade_reasons = {}, onClick = () => { } }: ForecastGradeProps) => {

    const theme = useTheme();

    const getGradeColor = (grade?: string): string => {
        switch (grade) {
            case 'A':
                return theme.palette.success.main;
            case 'B':
                return '#FFCC00'
            case 'C':
                return theme.palette.warning.main;
            case 'D':
                return theme.palette.error.main
            case 'NONE':
                return theme.palette.grey[500];
        }
        return theme.palette.grey[500];
    }


    const getGradeLabel = (grade?: string): string => {
        switch (grade) {
            case 'A':
                return 'Good';
            case 'B':
                return 'Fair';
            case 'C':
                return 'Poor';
            case 'D':
                return 'Very Poor';
            case 'NONE':
                return 'None';
        }
        return 'Unknown';
    }


    const getSize = (size?: 'small' | 'medium' | 'large'): number => {
        switch (size) {
            case 'small':
                return 24;
            case 'medium':
                return 32;
            case 'large':
                return 40;
        }
        return 24;
    }

    return (
        <Tooltip title={"Forecast accuracy grade"}>
            <Stack direction="row" alignItems="center" spacing={2}>
                <Stack
                    component={!!onClick ? ButtonBase : 'div'}
                    onClick={onClick}
                    alignItems="center"
                    justifyContent="center"
                    minWidth={getSize(size)}
                    sx={{
                        backgroundColor: disabled ? addTransparency(theme.palette.grey[500], 0.2) : addTransparency(getGradeColor(grade), 0.2),
                        borderRadius: '100px',
                        aspectRatio: 1,
                    }}
                >
                    <Typography fontSize={`${getSize(size) / 2}px`} color={disabled ? theme.palette.grey[500] : getGradeColor(grade)} >
                        {grade === 'NONE' ? '—' : (grade || '-')}
                    </Typography>
                </Stack>


                {showLabel && (
                    <Stack direction="column" spacing={0}>
                        <Typography variant="body1" fontWeight={500} color={disabled ? theme.palette.grey[500] : getGradeColor(grade)}>{getGradeLabel(grade)}</Typography>
                        {grade_reasons && grade_reasons && (
                            <>
                                <Typography variant="body2" color="text.secondary">{grade_reasons[Object.keys(grade_reasons)[0]]}</Typography>

                                {Object.keys(grade_reasons).length > 1 && (
                                    <Add
                                        fontSize="small"
                                        color="primary"
                                        component="span"
                                    />
                                )}
                            </>
                        )}
                    </Stack>
                )}

            </Stack>
        </Tooltip>
    );
};

export default ForecastGrade;